import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "users",
  class: "users"
}
const _hoisted_2 = {
  key: 0,
  class: "user-stats"
}
const _hoisted_3 = { class: "user-header" }
const _hoisted_4 = {
  key: 2,
  class: "content"
}
const _hoisted_5 = { class: "ellipsis-cell" }
const _hoisted_6 = { class: "ellipsed" }
const _hoisted_7 = { class: "ellipsis-cell" }
const _hoisted_8 = { class: "ellipsed" }
const _hoisted_9 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_UserStats = _resolveComponent("UserStats")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Empty = _resolveComponent("Empty")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_EditProfileModal = _resolveComponent("EditProfileModal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.selected_user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_IconAsButton, {
              hoverable: "",
              icon: "arrow-left",
              size: "2rem",
              "stroke-width": "1",
              onClick: _cache[0] || (_cache[0] = $event => ($data.selected_user = undefined))
            }),
            _createElementVNode("div", null, _toDisplayString($data.selected_user.display_name) + " (" + _toDisplayString($data.selected_user.email) + ")", 1 /* TEXT */)
          ]),
          _createVNode(_component_UserStats, {
            api: `${$options.API2_USERS}/${$data.selected_user.id}/stats`
          }, null, 8 /* PROPS */, ["api"])
        ]))
      : ($data.loading)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 1 }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Loading"),
              _createElementVNode("br", null, null, -1 /* HOISTED */),
              _createTextVNode(" Please wait... ")
            ])),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!$options.view_total)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($data.load_params.filter)
                    ? (_openBlock(), _createBlock(_component_Empty, {
                        key: 0,
                        bg: "assets/bg-pattern-decorative.png"
                      }, {
                        "sub-text": _withCtx(() => [
                          _cache[4] || (_cache[4] = _createTextVNode(" There are no users matching your criteria")),
                          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                          _createElementVNode("a", {
                            class: "pointer",
                            onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.onSearch(undefined)), ["prevent"]))
                          }, "Clear filter")
                        ]),
                        image: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            width: "4rem",
                            height: "4rem",
                            icon: "user-03",
                            "stroke-width": "1",
                            stroke: "var(--gray-500)"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : (_openBlock(), _createBlock(_component_Empty, {
                        key: 1,
                        bg: "assets/bg-pattern-decorative.png"
                      }, {
                        title: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("There are no users at the moment")
                        ])),
                        image: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            width: "4rem",
                            height: "4rem",
                            icon: "user-03",
                            "stroke-width": "1",
                            stroke: "var(--gray-500)"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createBlock(_component_DataTable, {
                  key: 1,
                  class: "table",
                  items: $options.view_items,
                  loading: $options.refreshing,
                  total: $options.view_total,
                  skip: $data.load_params.skip,
                  "override-skip": "",
                  onPage: $options.onPage
                }, {
                  "header-left": _withCtx(() => [
                    _createElementVNode("small", null, "Users in Tenant: " + _toDisplayString($options.view_total), 1 /* TEXT */)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { field: "name" }, {
                      header: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" Name ")
                      ])),
                      body: _withCtx(({data: {display_name}}) => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, _toDisplayString(display_name), 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_Column, { field: "email" }, {
                      header: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Email ")
                      ])),
                      body: _withCtx(({data: {email}}) => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(email), 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_Column, { field: "actions" }, {
                      body: _withCtx(({data}) => [
                        _createElementVNode("div", {
                          class: "controls",
                          disabled: data.updating
                        }, [
                          _createVNode(_component_IconAsButton, {
                            icon: "pencil-02",
                            tooltip: "Edit User",
                            onClick: $event => (_ctx.$refs.editModal.open(data))
                          }, null, 8 /* PROPS */, ["onClick"]),
                          _createVNode(_component_IconAsButton, {
                            icon: "bar-chart-square-02",
                            tooltip: "Stats",
                            onClick: _withModifiers($event => ($data.selected_user = data), ["prevent"])
                          }, null, 8 /* PROPS */, ["onClick"]),
                          _createVNode(_component_IconAsButton, {
                            icon: "download-02",
                            tooltip: "Download Followed Entities",
                            onClick: $event => ($options.onDownloadFollowed(data.id))
                          }, null, 8 /* PROPS */, ["onClick"])
                        ], 8 /* PROPS */, _hoisted_9)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["items", "loading", "total", "skip", "onPage"])),
            _createVNode(_component_EditProfileModal, {
              ref: "editModal",
              onSubmit: _cache[2] || (_cache[2] = $event => ($data.store.replaceUser($event)))
            }, null, 512 /* NEED_PATCH */)
          ]))
  ]))
}